import * as React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { Grid } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Divider from "@mui/material/Divider";
import { useState } from "react";
import CommonSelectWithoutNoneOption from "components/CommonSelect/selectWithoutNoneOption";
import { getFormCatalog } from "rest/requests";
import { useEffect } from "react";
import { useCallback } from "react";
import { getCatalogSectors } from "rest/requests";
import { getCatalogSubSectors } from "rest/requests";
import { getCatalogGroups } from "rest/requests";
import { getCatalogCategories } from "rest/requests";
import { createProduct } from "rest/requests";
import swal from "sweetalert";
import { editProduct } from "rest/requests";

const createNewProduct = (
  name,
  code,
  presentation,
  administration,
  categoryId,
  sectorId,
  subSectorId,
  unitContent,
  groupId,
  companyId,
  manufacturer,
  formId,
  activeMolecularCompound,
  setEditing
) => {
  createProduct(
    name,
    code,
    presentation,
    administration,
    categoryId,
    sectorId,
    subSectorId,
    unitContent,
    groupId,
    companyId,
    manufacturer,
    formId,
    activeMolecularCompound
  )
    .then((req, res) => {
      console.log("Response...", res);
      swal("Ok", "Producto creado exitosamente", "success");
    })
    .catch((error) => {
      swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
      console.log("Error updating Product: ", error);
    });
  setEditing(false);
};

const editProductFunc = (
  idProduct,
  name,
  code,
  presentation,
  administration,
  categoryId,
  sectorId,
  subSectorId,
  unitContent,
  groupId,
  companyId,
  manufacturer,
  formId,
  activeMolecularCompound,
  setEditing
) => {
  editProduct(
    idProduct,
    name,
    code,
    presentation,
    administration,
    categoryId,
    sectorId,
    subSectorId,
    unitContent,
    groupId,
    companyId,
    manufacturer,
    formId,
    activeMolecularCompound
  )
    .then((req, res) => {
      console.log("Response...", res);
      swal("Ok", "Producto modificado exitosamente", "success");
    })
    .catch((error) => {
      swal("Oops!", "Algo a salido mal durante el procesamiento", "error");
      console.log("Error updating Product: ", error);
    });
  setEditing(false);
};

function EditProduct({ productToEdit, setEditing, selectedCompany }) {
  const [code, setCode] = useState(productToEdit ? productToEdit.code : "");
  const [name, setName] = useState(productToEdit ? productToEdit.name : "");
  const [manufacturer, setManufacturer] = useState(productToEdit ? productToEdit.manufacturer : "");
  const [presentation, setPresentation] = useState(productToEdit ? productToEdit.presentation : "");
  const [administration, setAdministration] = useState(
    productToEdit ? productToEdit.administration : ""
  );
  const [unitContent, setUnitContent] = useState(productToEdit ? productToEdit.unitContent : "");
  const [selectedForm, setSelectedForm] = useState(productToEdit ? productToEdit.form.id : "");
  const [selectedSector, setSelectedSector] = useState(
    productToEdit ? productToEdit.sector.id : ""
  );
  const [selectedSubSector, setSelectedSubSector] = useState(
    productToEdit ? productToEdit.subSector.id : ""
  );
  const [selectedGroup, setSelectedGroup] = useState(productToEdit ? productToEdit.group.id : "");
  const [selectedCategory, setSelectedCategory] = useState(
    productToEdit ? productToEdit.category.id : ""
  );

  const [formCatalogs, setFormCatalogs] = useState([]);
  const [sectorCatalogs, setSectorCatalogs] = useState([]);
  const [subSectorCatalogs, setSubSectorCatalogs] = useState([]);
  const [groupCatalogs, setGroupCatalogs] = useState([]);
  const [categoryCatalogs, setCategoryCatalogs] = useState([]);
  const [molecularCompound, setMolecularCompound] = useState(
    productToEdit ? productToEdit.activeMolecularCompound : ""
  );

  const filteredSubSectorCatalogs = (selectedSector, subSectorCatalogs) => {
    // :param subSectorCatalogs: [
    //   {
    //     "id": 29,
    //     "name": "VARIOS AVICULTURA",
    //     "abbreviation": "VAV",
    //     "catalogTypeId": 3,
    //     "filteredL1": [
    //         {
    //             "id": 12,
    //             "name": "AVICULTURA",
    //             "abbreviation": "AVI",
    //             "catalogTypeId": 2
    //         }
    //     ]
    // }
    // ]
    if (!selectedSector) {
      return subSectorCatalogs;
    }
    return subSectorCatalogs.filter((subSector) => {
      if ("filteredL1" in subSector) {
        return subSector.filteredL1.map((elem) => elem.id).includes(selectedSector);
      }
      return true;
    });
  };

  const filteredGroupCatalogs = (selectedSubSector, groupCatalogs) => {
    // :param groupCatalogs: [
    //   {
    //     "id": 110,
    //     "name": "ALIMENTO BALANCEADO",
    //     "abbreviation": "ALB",
    //     "catalogTypeId": 1,
    //     "filteredL1": [
    //         {
    //             "id": 990,
    //             "name": "ALIMENTO BALANCEADO",
    //             "abbreviation": "ALB",
    //             "catalogTypeId": 3
    //         }
    //     ]
    // }
    // ]
    if (!selectedSubSector) {
      return groupCatalogs;
    }
    return groupCatalogs.filter((group) => {
      if ("filteredL1" in group) {
        return group.filteredL1.map((elem) => elem.id).includes(selectedSubSector);
      }
      return true;
    });
  };

  const filteredCategoryCatalogs = (selectedGroup, categoryCatalogs) => {
    // :param categoryCatalogs: [
    //   {
    //     "id": 154,
    //     "name": "ALBENDAZOLES",
    //     "abbreviation": "ALB",
    //     "catalogTypeId": 6,
    //     "filteredL1": [
    //         {
    //             "id": 72,
    //             "name": "ANTIPARASITARIOS INTERNOS",
    //             "abbreviation": "AIN",
    //             "catalogTypeId": 1
    //         }
    //     ],
    //     "filteredL2": [
    //         {
    //             "id": 6,
    //             "name": "GANADERIA",
    //             "abbreviation": "GAN",
    //             "catalogTypeId": 2
    //         }
    //     ]
    // }
    // ]
    if (!selectedGroup) {
      return categoryCatalogs;
    }
    return categoryCatalogs.filter((category) => {
      if ("filteredL1" in category) {
        return category.filteredL1.map((elem) => elem.id).includes(selectedGroup);
      }
      if ("filteredL2" in category) {
        return category.filteredL2.map((elem) => elem.id).includes(selectedGroup);
      }
      return true;
    });
  };

  const getData = useCallback(async () => {
    setFormCatalogs(await getFormCatalog());
    setSectorCatalogs(await getCatalogSectors());
    setSubSectorCatalogs(await getCatalogSubSectors());
    setGroupCatalogs(await getCatalogGroups());
    setCategoryCatalogs(await getCatalogCategories());
  }, [selectedForm, selectedSector, selectedSubSector, selectedGroup, selectedCategory]);

  useEffect(() => {
    getData();
  }, []);

  const checkInput = () => {
    return (
      name != "" &&
      code != "" &&
      manufacturer != "" &&
      presentation != "" &&
      administration != "" &&
      unitContent != "" &&
      selectedSector &&
      selectedSubSector &&
      selectedGroup &&
      selectedCategory &&
      selectedForm
    );
  };

  return (
    <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
      <Grid container marginTop={1}>
        <Grid item lg={6} padding={1} minWidth={300}>
          <MDInput
            variant="outlined"
            type="text"
            label="Nombre"
            value={name}
            fullWidth={true}
            onChange={(event) => setName(event.target.value)}
            success={name != ""}
            error={name === ""}
          />
        </Grid>
        <Grid item lg={6} padding={1} minWidth={300}>
          <MDInput
            variant="outlined"
            type="text"
            label="Codigo"
            value={code}
            fullWidth={true}
            onChange={(event) => setCode(event.target.value)}
            success={code != ""}
            error={code === ""}
          />
        </Grid>
      </Grid>

      <Grid container marginTop={1}>
        <Grid item lg={6} padding={1} minWidth={300}>
          <MDInput
            variant="outlined"
            type="text"
            label="Fabricado"
            value={manufacturer}
            fullWidth={true}
            onChange={(event) => setManufacturer(event.target.value)}
            success={manufacturer != ""}
            error={manufacturer === ""}
          />
        </Grid>
        <Grid item lg={6} padding={1} minWidth={300}>
          <MDInput
            variant="outlined"
            type="text"
            label="Presentacion"
            value={presentation}
            fullWidth={true}
            onChange={(event) => setPresentation(event.target.value)}
            success={presentation != ""}
            error={presentation === ""}
          />
        </Grid>
      </Grid>

      <Grid container marginTop={1}>
        <Grid item lg={6} padding={1} minWidth={300}>
          <MDInput
            variant="outlined"
            type="text"
            label="Administración"
            value={administration}
            fullWidth={true}
            onChange={(event) => setAdministration(event.target.value)}
            success={administration != ""}
            error={administration === ""}
          />
        </Grid>
        <Grid item lg={6} padding={1} minWidth={300}>
          <MDInput
            variant="outlined"
            type="text"
            label="Contenido Unitario"
            value={unitContent}
            fullWidth={true}
            onChange={(event) => setUnitContent(event.target.value)}
            success={unitContent != ""}
            error={unitContent === ""}
          />
        </Grid>
      </Grid>

      <Grid container marginTop={1}>
        <Grid item sm={6} padding={1} minWidth={300}>
          <MDInput
            variant="outlined"
            type="text"
            label="Compuesto Molecular Activo"
            value={molecularCompound}
            fullWidth={true}
            onChange={(event) => setMolecularCompound(event.target.value)}
          />
        </Grid>
      </Grid>
      <Divider></Divider>
      <Grid container marginTop={1}>
        {sectorCatalogs ? (
          <Grid item padding={1}>
            <CommonSelectWithoutNoneOption
              data={sectorCatalogs}
              onChange={setSelectedSector}
              label={"Sector"}
              defaultValue={selectedSector}
            />
          </Grid>
        ) : (
          <></>
        )}
        {subSectorCatalogs ? (
          <Grid item padding={1}>
            <CommonSelectWithoutNoneOption
              data={filteredSubSectorCatalogs(selectedSector, subSectorCatalogs)}
              onChange={setSelectedSubSector}
              label={"Sub-Sector"}
              defaultValue={selectedSubSector}
            />
          </Grid>
        ) : (
          <></>
        )}
      </Grid>

      <Grid container marginTop={1}>
        {groupCatalogs ? (
          <Grid item padding={1}>
            <CommonSelectWithoutNoneOption
              data={filteredGroupCatalogs(selectedSubSector, groupCatalogs)}
              onChange={setSelectedGroup}
              label={"Grupo"}
              defaultValue={selectedGroup}
            />
          </Grid>
        ) : (
          <></>
        )}
        {categoryCatalogs ? (
          <Grid item padding={1}>
            <CommonSelectWithoutNoneOption
              data={filteredCategoryCatalogs(selectedGroup, categoryCatalogs)}
              onChange={setSelectedCategory}
              label={"Categoría"}
              defaultValue={selectedCategory}
            />
          </Grid>
        ) : (
          <></>
        )}
        {formCatalogs ? (
          <Grid item padding={1}>
            <CommonSelectWithoutNoneOption
              data={formCatalogs}
              onChange={setSelectedForm}
              label={"Forma Farmacéutica"}
              defaultValue={selectedForm}
            />
          </Grid>
        ) : (
          <></>
        )}
      </Grid>

      <Divider></Divider>

      <Grid container marginTop={2}>
        <Grid item padding={2}>
          <MDButton variant="outlined" color="info" onClick={() => setEditing(false)}>
            Atras
          </MDButton>
        </Grid>

        <Grid item padding={2}>
          {productToEdit ? (
            <MDButton
              disabled={!checkInput()}
              variant="contained"
              color="info"
              onClick={() =>
                editProductFunc(
                  productToEdit.id,
                  name,
                  code,
                  presentation,
                  administration,
                  selectedCategory,
                  selectedSector,
                  selectedSubSector,
                  unitContent,
                  selectedGroup,
                  selectedCompany,
                  manufacturer,
                  selectedForm,
                  molecularCompound,
                  setEditing
                )
              }
            >
              Actualizar
            </MDButton>
          ) : (
            <MDButton
              disabled={!checkInput()}
              variant="contained"
              color="info"
              onClick={() =>
                createNewProduct(
                  name,
                  code,
                  presentation,
                  administration,
                  selectedCategory,
                  selectedSector,
                  selectedSubSector,
                  unitContent,
                  selectedGroup,
                  selectedCompany,
                  manufacturer,
                  selectedForm,
                  molecularCompound,
                  setEditing
                )
              }
            >
              Adicionar
            </MDButton>
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default EditProduct;

EditProduct.defaultProps = {
  productToEdit: null,
  setEditing: null,
  selectedCompany: null,
};

EditProduct.propTypes = {
  productToEdit: PropTypes.object,
  setEditing: PropTypes.func,
  selectedCompany: PropTypes.number,
};
